// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  color?: string,
  centered?: boolean,
  extra?: boolean,
};

const StyledStrong = styled.strong`
  font-family: ${props => props.extra ? 'InterBold' : 'InterSemibold'};
  line-height: 1.4;
  font-size: inherit;
  margin: 0;
  color: ${props => props.color || 'inherit'};
`;

export default function TextStrong(props: TProps): React.Node {
  return (
    <StyledStrong {...props}>
      {props.children}
    </StyledStrong>
  );
}
